<template>
  <ets-popup title="Fichero Generado" v-if="display" @close="closePopup()" hideFooter>
    <p>
      XML generado correctamente. Generado el XML se debe enviar por Sede Electrónica a la CMNV.
    </p>
  </ets-popup>
</template>

<script>
export default {
  name: "PopupGenerated",
  props: {
    displayGenerate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    display: false
  }),
  methods: {
    closePopup() {
      this.display = false;
      this.$emit("display-generate", this.display);
    }
  },
  watch: {
    displayGenerate: {
      immediate: true,
      handler() {
        this.display = this.displayGenerate;
      }
    }
  }
};
</script>
